import React from 'react'

import { COLORS, THEME_CONST, Z_INDEX } from '../../../theme'
import { styled } from '../../../theme/styled'
import { MsdkStyledComponent } from '../../../utils'
import { Logo } from '../../Icons'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const StyledWrapper: MsdkStyledComponent<any> = styled('div')`
  display: flex;
  flex-flow: nowrap;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  position: absolute;
  padding: 0 16px 0 20px;
  top: 0;
  height: ${THEME_CONST.navHeight}px;
  z-index: ${Z_INDEX.under_dropdown};
  background-color: ${COLORS.blue700};
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14);
`
interface Props {
  children?: React.ReactNode
  onLogoClick?: () => void
}

export function ApplicationHeaderWrapper(props: Props) {
  const handleClick = () => {
    if (props.onLogoClick) props.onLogoClick()
  }

  return (
    <StyledWrapper data-test-id="SHELL-HEADER-CONTAINER">
      <Logo onClick={handleClick} />
      {props.children}
    </StyledWrapper>
  )
}
